// extracted by mini-css-extract-plugin
export default {"color":"ElectricAdditionalPrice_color__4Mqj0"};